import React, { Component } from "react";
import customFetch from "./apicall/api";
import { isElementOfType } from "react-dom/test-utils";
import { useHistory } from "react-router-dom";
import { logout, chkapiinput, generateId } from "./Utility";
import { ThemeContext } from "../context/IsLoader";
import { PEButton, PEDiv, PEImg, PEInput, PEA, PESpan, PELI, PETextArea } from "./permissionComponents";
const generate_Id1 = generateId(10);
export default class SubmitReversal extends Component {
  static contextType = ThemeContext;
  constructor(props) {
    super(props);

    this.state = {
      isSubbmitted: false,
      api_token: localStorage.getItem("api_token"),
      txn_ref_no: props.location.state.txn_ref_no,
      txn_details: null,
      acronym: "",
      remark: "",
      form_error: "",
      disabled: false,
      isSpin: false,
      flag: 0,
    };
  }

  fetchDetails = async () => {
    try {
      const api_token = this.state.api_token;
      /*Check if data is null then logout*/
      var arr = [this.state.txn_ref_no];
      var chkdata = chkapiinput(arr);
      if (chkdata === false) {
        this.setState({ isSpin: false });
        setTimeout(function() {
          logout();
        }, 2000);
      }
      /*Check if data is null then logout End*/

      const params = {
        txn_ref_no: this.state.txn_ref_no,
      };
      const queryParams = new URLSearchParams(params).toString();
      let generate_Id = generateId(10);
      const requestOptions = {
        method: "GET",
        headers: {
          "api-token": api_token,
          component_id: generate_Id1,
          apiId: generate_Id,
          api_group_id: "",
          component: this.constructor.name,
          user_id: localStorage.getItem("in_userid"),
        },
      };

      const response = await customFetch(
        process.env.REACT_APP_URL + "/reversal/detail?" + queryParams,
        requestOptions
      );

      const data = await response.json();
      data.collection_detail.sort((a, b) => {
        return a.partner_id - b.partner_id;
      });
      console.log(data);
      return data;
    } catch (e) {
      console.error(e);
    }
  };

  componentDidMount() {
    if (
      window.Android &&
      typeof window.Android.getDataFromLocalStorage === "function"
    ) {
      const data = window.Android.getDataFromLocalStorage("your_key");
      if (data) {
        this.setState({ isSpin: false, flag: 1 }); // Set flag to 1 if accessed from Android
        const tokenParts = data.split(",");
        const tokenData = {};

        tokenParts.forEach((part) => {
          const [key, value] = part.split(":");
          tokenData[key] = value;
        });

        console.log("AndroidInterface->", data);
      }
    } else {
      console.log(
        "Error in AndroidInterface: Android method not found or not available."
      );
    }

    setTimeout(() => {
      if (document.readyState === "complete") {
        this.context.onPageLoad({
          component: this.constructor.name,
          component_id: generate_Id1,
        });
      } else {
        window.addEventListener("load", this.context.onPageLoad());
        this.cleanup = () =>
          window.removeEventListener("load", this.context.onPageLoad());
      }
    }, 1000);
    const uid = localStorage.getItem("in_userid");
    if (!uid) {
      localStorage.clear();
      this.props.history.push("/");
    }
    this.setState({ isSpin: true });
    this.fetchDetails().then((txn_details) => {
      let acronym = txn_details.household_name
        .split(/\s/)
        .reduce((response, word) => (response += word.slice(0, 1)), "")
        .slice(0, 2)
        .toUpperCase();
      this.setState({ txn_details, acronym, isSpin: false });
    });
  }

  // logout = () => {
  //   localStorage.clear();
  //   this.props.history.push("/");
  // };

  handleChange = (e) => {
    this.setState({ remark: e.target.value });
  };

  handleSubmit = async () => {
    try {
      this.setState({ form_error: "", disabled: true, isSpin: true });
      if (this.state.remark == "" || this.state.remark == null) {
        this.setState({
          form_error: "please enter the remarks",
          disabled: false,
          isSpin: false,
        });
        return;
      } else if (this.state.remark.length <= 10) {
        this.setState({
          form_error: "remark must be more than 10 charecters",
          disabled: false,
          isSpin: false,
        });
        return;
      } else if (this.state.remark.length >= 90) {
        this.setState({
          form_error: "remark must be less than 90 charecters",
          disabled: false,
          isSpin: false,
        });
        return;
      }
      const api_token = this.state.api_token;
      /*Check if data is null then logout*/
      var arr = [
        this.state.txn_details.txn_ref_no,
        localStorage.getItem("in_userid"),
        this.state.remark,
      ];
      var chkdata = chkapiinput(arr);
      if (chkdata === false) {
        this.setState({ isSpin: false });
        setTimeout(function() {
          logout();
        }, 2000);
      }
      /*Check if data is null then logout End*/
      const formdata = new FormData();
      formdata.append("txn_ref_no", this.state.txn_details.txn_ref_no);
      formdata.append("userid", localStorage.getItem("in_userid"));
      formdata.append("remark", this.state.remark);
      let generate_Id = generateId(10);
      const requestOptions = {
        method: "POST",
        headers: {
          "api-token": api_token,
          component_id: generate_Id1,
          apiId: generate_Id,
          api_group_id: "",
          component: this.constructor.name,
          user_id: localStorage.getItem("in_userid"),
        },
        body: formdata,
      };

      const response = await customFetch(
        process.env.REACT_APP_URL + "/reversal/submit",
        requestOptions
      );

      const data = await response.json();
      if (data.status_code != 200) throw "Internal Server Error";
      this.setState({ isSubbmitted: true, disable: false, isSpin: false });
    } catch (e) {
      console.error(e);
    }
  };

  render() {
    let s_no = 1;
    return (
      <>
        {this.state.isSpin ? (
          <div class="preloader">
            <div class="loader" ng-hide="data.length > 0"></div>
          </div>
        ) : (
          ""
        )}
        <div className="container">
          <div className="reversal_navbar">
            <button
              className="button back_button"
              onClick={() => this.props.history.goBack()}
            >
              <img src={require("../assets/images/back.png")} />
            </button>
            <span>Submit Reversal</span>
            <button className="button" onClick={() => logout(null, null, true)}>
              <img src={require("../assets/images/power-off.png")} alt="" />
            </button>
          </div>
          {!this.state.isSubbmitted ? (
            this.state.txn_details ? (
              <div className="reversal_details_card">
                <div className="reversal_details_card_header">
                  <PEDiv element_id="SubmitReversalHHShortName">{this.state.acronym}</PEDiv>
                  <ul className="reversal_hh_info">
                    <PELI element_id="SubmitReversalRefNo">Ref no: {this.state.txn_details.txn_ref_no}</PELI>
                    <PELI element_id="SubmitReversalHHID">HH ID : {this.state.txn_details.household_number}</PELI>
                    <PELI element_id="SubmitReversalHHName">{this.state.txn_details.household_name}</PELI>
                  </ul>
                </div>
                <PEDiv element_id="SubmitReversalAmount" className="reversal_trans_card_amount">
                  <span>Amount :</span>
                  <span>
                    Rs. {this.state.txn_details.amount.toLocaleString()}
                  </span>
                </PEDiv>
                {this.state.txn_details.collection_detail.map((item, index) => {
                  return (
                    <div key={index} className="reversal_details_bal_block">
                      <h4>
                        {item.partner_id != "1"
                          ? "Partner " + s_no++ + ":"
                          : ""}{" "}
                        {item.partner}
                      </h4>
                      <div className="reversal_bal_block_main">
                        {item.P && (
                          <PEDiv element_id="SubmitReversalCollectionAmount" className="reversal_bal_charges">
                            <span>Amount</span>
                            <span>Rs. {item.P}</span>
                          </PEDiv>
                        )}
                        {item.C && (
                          <PEDiv element_id="SubmitReversalCollectionCharges" className="reversal_bal_emi">
                            <span>Charges</span>
                            <span>Rs. {item.C}</span>
                          </PEDiv>
                        )}
                        {/* <div className='reversal_bal_overdue'>
                           <span>Overdue</span>
                           <span>Rs. 10,000</span>
                       </div> */}
                      </div>
                    </div>
                  );
                })}
                <PETextArea element_id="SubmitReversalComments"
                  value={this.state.remark}
                  onChange={this.handleChange}
                  type="text"
                  name="comments"
                  placeholder="comments"
                  maxLength="150"
                ></PETextArea>
                {this.state.form_error != "" ? (
                  <span className="text-danger mt-2 mb-2">
                    *{this.state.form_error}
                  </span>
                ) : (
                  ""
                )}
                <PEButton element_id="SubmitReversalSubmitBtn"
                  className="reversal_button"
                  disabled={this.state.disabled}
                  onClick={this.handleSubmit}
                >
                  Submit
                </PEButton>
              </div>
            ) : (
              ""
            )
          ) : (
            <ReversalSubmitted />
          )}
        </div>
      </>
    );
  }
}

function ReversalSubmitted() {
  const history = useHistory();
  return (
    <div className="reversal_details_card">
      <div className="reversal_details_card_header">
        Transaction is Successfully Submitted for Reversal.
      </div>
      <button
        className="reversal_button"
        onClick={() => {
          history.goBack();
        }}
      >
        OK
      </button>
    </div>
  );
}
